<template>
	<div class=".pt-12 .mt-2">
		<v-row align="center" justify="center" dense no-gutters class="ml-4 mr-4 mt-2">
			<!--OPCION MENU -->
			<v-col v-for="opt in menu" :key="opt.titulo" cols="6" md="4">
				<v-card
					:to="{ name: opt.link }"
					class="text-center pt-4"
					outlined
					tile
					min-height="135"
					max-height="135"
				>
					<!--ICONO -->
					<v-img>
						<v-icon size="50" color="primary">{{ opt.icon }}</v-icon>
					</v-img>
					<!--TITULO -->
					<v-card-text
						><h3 class="black--text">{{ opt.titulo }}</h3>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>

		<!-- MODAL 1ER VEZ -->
		<v-dialog v-model="dialog" persistent>
			<v-card align="center">
				<v-card-title class="headline">Notificaciones WEB</v-card-title>
				<v-icon color="primary" size="55">mdi-bell</v-icon>
				<v-card-text align="center" class="black--text mt-2">
					¿Desea recibir notificaciones sobre la UCAB de parte del Centro de
					Estudiante?</v-card-text
				>
				<v-card-actions id="acciones">
					<v-spacer></v-spacer>
					<v-btn text @click="dialog = false">Descartar</v-btn>
					<v-btn color="primary" @click="suscribirUsuario">Suscribirse</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- WAITING -->
		<v-snackbar bottom :timeout="0" v-model="snackbar">
			<div>
				<v-progress-circular indeterminate size="16" width="3"></v-progress-circular>
				<span class="pl-2"> Suscribiendo...</span>
			</div>
		</v-snackbar>
	</div>
</template>

<script>
import store from "../store/index";
import { sendTopics, messaging } from "../firebase";

export default {
	data: () => {
		return {
			dialog: store.getters.isPrimeraVez,
			snackbar: false,
			menu: [
				{ titulo: "UCalculadora", link: "Ucalculadora", icon: "mdi-calculator" },
				{ titulo: "Horarios+", link: "HorariosPlus", icon: "mdi-clock-outline" },
				//{ titulo: "Calendario de Eventos", link: "Calendario", icon: "mdi-calendar-text" },
				{ titulo: "Material de Estudio", link: "Material", icon: "mdi-library" },
				{ titulo: "Contactos UCAB", link: "Contactos", icon: "mdi-account-supervisor" },
				//{ titulo: "Anuncios UCAB", link: "Anuncios", icon: "mdi-tooltip-text" },
				///*{ titulo: "Procesos UCAB", link: "Procesos", icon: "mdi-note-text" },*/
				//{ titulo: "Asesorias Académicas", link: "Progresa", icon: "mdi-google-classroom" },
				/*{
					titulo: "Contingencia Académica",
					link: "Contingencia",
					icon: "mdi-car-brake-alert"
				},*/
				//{ titulo: "Horarios de Consultas", link: "Consultas", icon: "mdi-teach" },
				{
					titulo: "Biblioteca UCAB",
					link: "BibliotecaUcab",
					icon: "mdi-book-open-page-variant",
				},
			],
		};
	},
	created() {
		store.commit("toggleTabs", false);
	},
	methods: {
		suscribirUsuario() {
			this.snackbar = true;
			this.dialog = false;
			messaging
				.getToken()
				.then((currentToken) => {
					//console.warn("TOKEN FB: ", currentToken);
					if (currentToken) {
						sendTopics({
							academico: true,
							administrativo: true,
							carrera: true,
							token: currentToken,
						});

						this.$ua.trackEvent(`CplusInteraccion`, "Suscribirse", "All");
					}
				})
				.catch((err) => {
					console.error("An error occurred while retrieving token. ", err);
				})
				.finally(() => {
					this.snackbar = false;
				});
		},
	},
};
</script>
